/**
 * Reducer for feature flags
 */

import { fromJS, Map } from 'immutable';

import { SET_FEATURE_FLAGS } from './actions';

export const FEATURE_FLAGS_KEY = 'featureFlags';

const DEFAULT_STATE = Map({});

export function featureFlagsReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case SET_FEATURE_FLAGS:
            if (action.flags) {
                return fromJS(action.flags);
            }
            return state;
    }

    return state;
}
